import { LICENSE_MODULE } from "@selector/shared";
import { type FC } from "react";
import { useSelector } from "react-redux";

import { type Configuration } from "../../graphql.js";
import { filterByClassicProcessorDisabled, filterByLicense } from "../../redux/modules/config.js";
import { type IAppState } from "../../redux/reducer.js";
import { EXT_APP_MODULES } from "../../settings/settings.js";
import PageLayout from "../core/navigation-panel/PageLayout.js";
import { type IRouteNavItemProps } from "../core/navigation-panel/RouteNavItem.js";
import SystemDetailsPage from "./SystemDetailsPage.js";

const ADMIN_SYSTEM_NAV_ITEMS: IRouteNavItemProps[] = [
  {
    route: "analyst",
    label: EXT_APP_MODULES.ANALYST.name,
    licenseModule: LICENSE_MODULE.ANALYST,
    pageComponent: <SystemDetailsPage systemId={EXT_APP_MODULES.ANALYST.id} />,
    default: true,
  },
  {
    route: "processor",
    label: EXT_APP_MODULES.PROCESSOR.name,
    licenseModule: LICENSE_MODULE.PROCESSOR,
    pageComponent: <SystemDetailsPage systemId={EXT_APP_MODULES.PROCESSOR.id} />,
    isClassicProcessor: true,
  },
];

/**
 * System Admin Page main component
 */
const SystemAdminPage: FC = () => {
  const configuration = useSelector<IAppState, Configuration>((state) => state.config.configuration);

  return (
    <PageLayout
      navPanelCategories={[
        {
          label: "System Administration",
          navItems: filterByClassicProcessorDisabled(
            filterByLicense(ADMIN_SYSTEM_NAV_ITEMS, configuration),
            configuration,
          ),
        },
      ]}
    />
  );
};

export default SystemAdminPage;
